import { H3, MarginBox } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function FamilyColumnHeading({ type }: { type: 'spouses' | 'parents' }): JSX.Element {
  const [t] = useTranslation()
  const headingText =
    type === 'spouses' ? t('tree-person.spouses-and-children.label') : t('tree-person.parents-and-siblings.label')

  return (
    <MarginBox marginY="nano">
      <H3 size="H5" supplementary>
        {headingText}
      </H3>
    </MarginBox>
  )
}
